import {Box, Stack, Typography} from '@mui/material';
import ATPLogo from '../../../images/AtpLab/atp_lab_logo.png';
import mainLogo from '../../../images/logo_black_letters_2.png';

/**
 * AtplFooter component
 * This component represents the ATPL footer section of the page with a customizable title.
 * It can be reused across the application by passing different titles through the `footerTitle` prop.
 *
 * @param {Object} props - The props for the footer component.
 * @param {string} props.footerTitle - The title to display in the footer.
 *
 * @returns {JSX.Element} A footer element with a dynamic title.
 */
// Render the ATPL footer with a dynamic title passed through the footerTitle prop.
const AtplFooter = ({footerTitle}) => {
  return (
    <Box sx={{marginY: '3px'}}>
      <Stack display="flex" justifyContent="center" width="100%" alignItems="center">
        <Stack>
          <Box
            component="a"
            href="https://atplab.com/?rfsn=8347543.b2a03c"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              display: 'inline-block',
              cursor: 'pointer',
            }}
          >
            <Box
              component="img"
              src={ATPLogo}
              alt="ATPL logo"
              sx={{
                width: {xs: '100px', sm: '120px', md: '136px', lg: '130px'},
                height: 'auto',
              }}
            />
          </Box>
        </Stack>

        <Stack
          display="flex"
          flexDirection="row"
          alignItems="center"
          height="50px"
          width="100%"
          justifyContent="center"
        >
          <Typography
            sx={{
              fontSize: '10px',
              marginTop: {xs: '2px', sm: '14px', md: '20px', lg: '10px'},
              fontWeight: '500',
              lineHeight: '15px',
            }}
          >
            {footerTitle ? footerTitle : 'Your health scan was powered by'}
          </Typography>
          <Box
            component="img"
            src={mainLogo}
            alt="AIMD logo"
            sx={{
              width: {xs: '40px', sm: '50px', md: '54px', lg: '54px'},

              height: 'auto',
              marginLeft: '10px',
              userSelect: 'none',
              paddingTop: {xs: '2px', sm: '14px', md: '16px', lg: '10px'},
            }}
          />
        </Stack>
      </Stack>
    </Box>
  );
};

export default AtplFooter;
